import styled from 'styled-components';

const StyledRelativeDiv = styled.div`
    flex: 1;
    position: relative;
`;

export default StyledRelativeDiv;
